import { 
	GET_STORE_OVERALLS_STATUSES, 
	GET_STORE_OVERALLS_STATUS,
	CREATE_STORE_OVERALLS_STATUS,
	UPDATE_STORE_OVERALLS_STATUS,
	DESTROY_STORE_OVERALLS_STATUS,
} from "./actions"

export function StoreOverallsStatusesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_STORE_OVERALLS_STATUSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_STORE_OVERALLS_STATUS}_FULFILLED`:
		case `${CREATE_STORE_OVERALLS_STATUS}_FULFILLED`:
		case `${UPDATE_STORE_OVERALLS_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_STORE_OVERALLS_STATUS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { StoreOverallsStatusesReducer } from "modules/store/overalls/statuses/reducer"

// store_overalls_statuses:StoreOverallsStatusesReducer,
